import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2123Status: 'idle',
    startProcess2123Error: undefined as any,
    loadUserParamsProcess2123Status: 'idle',
    loadUserParamsProcess2123Error: undefined as any,

    process2123List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2123 = createAsyncThunk('process2123Slice/startProcess2123', async ({ process2123 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2123/`,
        prepareData(process2123),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2123Status } = getState().process2123Slice
        return startProcess2123Status !== 'pending'
    }
})

export const loadUserParamsProcess2123 = createAsyncThunk('process2123Slice/loadUserParamsProcess2123', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2123/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2123Status } = getState().process2123Slice
        return loadUserParamsProcess2123Status !== 'pending'
    }
})

const Process2123Slice = createSlice({
    name: 'process2123Slice',
    initialState,
    reducers: {
        resetstartProcess2123: (state) => {
            state.job = undefined
            state.startProcess2123Error = undefined
        },
        resetstartProcess2123Error: (state) => {
            state.startProcess2123Error = undefined
        },
        resetloadUserParamsProcess2123: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2123Error = undefined
        },
        resetloadUserParamsProcess2123Error: (state) => {
            state.loadUserParamsProcess2123Error = undefined
        },
        removeFromProcess2123ListById: (state, action) => {
            state.process2123List = state.process2123List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2123ListByIds: (state, action) => {
            state.process2123List = state.process2123List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2123List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2123Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2123List = []
            state.startProcess2123Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2123.pending, (state) => {
            state.startProcess2123Status = 'pending'
            state.startProcess2123Error = undefined
        })
        builder.addCase(startProcess2123.fulfilled, (state, action) => {
            state.startProcess2123Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2123.rejected, (state, action) => {
            state.startProcess2123Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2123Error = action.error.message
            } else {
                state.startProcess2123Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2123.pending, (state) => {
            state.loadUserParamsProcess2123Status = 'pending'
            state.loadUserParamsProcess2123Error = undefined
        })
        builder.addCase(loadUserParamsProcess2123.fulfilled, (state, action) => {
            state.loadUserParamsProcess2123Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2123.rejected, (state, action) => {
            state.loadUserParamsProcess2123Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2123Error = action.error.message
            } else {
                state.loadUserParamsProcess2123Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2123,
    resetstartProcess2123Error,
    resetloadUserParamsProcess2123,
    resetloadUserParamsProcess2123Error,
    removeFromProcess2123ListById,
    removeFromProcess2123ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2123Slice.actions
export default Process2123Slice.reducer
